import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IOperative } from '../../../message-models/operative.interface';
import { TrainingRecordsService } from '../../services/training-records.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ITrainingRecord } from '../../../message-models/training-record.interface';
import { TrainingRecord } from '../../../domain-model/training-record.class';
import { ITrainingType } from '../../../message-models/training-record-type.interface';
import { OperativesService } from '../../../operatives/services/operatives.service';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { TrainingRecordDocumentService } from '../../services/training-record-document.service';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { DocumentService } from '../../../documents/services/document.service';
import { IObservation } from '../../../message-models/observation.interface';
import { ObservationModalService } from '../../../observations/services/observation-modal.service';
import { ObservationsService } from '../../../observations/services/observations.service';
import { Observation, ObservationType, ObservationTypeString } from '../../../domain-model/observation.class';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { DetailContainerComponent } from '../../../common/components/detail-container/detail-container.component';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { EcaConfirmDeleteModalOptions } from "../../../shared/models/confirm-delete-modal-options.class";
import { OperativeDocumentService } from '../../../operatives/services/operative-document.service';

@Component({
  selector: 'app-training-record-details',
  templateUrl: './training-record-details.component.html',
  styleUrls: ['./training-record-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TrainingRecordDetailsComponent implements OnInit {
  @ViewChild('trDetailsContainerComponent') trDetailsContainerComponent: DetailContainerComponent;
  operative: IOperative;
  editingDetails: boolean;
  trainingRecordObservations: Array<IObservationSummary> = new Array<IObservationSummary>();
  ObservationType: typeof ObservationType = ObservationType;
  private trainingRecordId: string;
  trainingRecordTypes: ITrainingType[] = [];
  trainingRecord: TrainingRecord = new TrainingRecord({} as ITrainingRecord);
  trainingRecordDocuments: IEntityDocumentSummary[] = [];
  public loggedInUser: IUserInfo;
  public companyId: string = consts.emptyGuid;
  loggedInUserSubscription: Subscription;
  tempTrainingRecord: TrainingRecord = new TrainingRecord({} as ITrainingRecord);
  isTrainingRecordLoading: boolean = false;
  observationsLoading: boolean = true;
  operativeObservationsSummary: Array<IObservationSummary>;


  // originalTrainingRecord: TrainingRecord = new TrainingRecord({} as ITrainingRecord);
  constructor(private route: ActivatedRoute,
    private trainingRecordsService: TrainingRecordsService,
    private trainingRecordDocumentService: TrainingRecordDocumentService,
    private operativesService: OperativesService,
    private operativeDocumentService: OperativeDocumentService,
    private helpService: HelpModalService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private documentModalService: DocumentModalService,
    private documentService: DocumentService,
    private confirmProcessService: EcaConfirmProcessService,
    private alertsService: AlertsService,
    private observationModalService: ObservationModalService,
    private observationsService: ObservationsService,
    private userService: OurUserService,
    private router: Router,
    private errorHandlingService: ErrorHandlingService) {
  }

  ngOnInit(): void {
 
    this.trainingRecordId = this.route.snapshot.params.trainingRecordId;
    this.isTrainingRecordLoading = true;
    this.userService.getLoggedInUser().subscribe(() => {

      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.loggedInUser = user;
        this.companyId = this.loggedInUser?.companyId;
        if (this.companyId !== consts.emptyGuid || this.companyId !== undefined) {

          this.trainingRecordsService.getTrainingRecordById(this.trainingRecordId).subscribe(trainingRecord => {
            this.trainingRecord = new TrainingRecord(trainingRecord);
            this.tempTrainingRecord = new TrainingRecord(this.trainingRecord as ITrainingRecord);
            // this.originalTrainingRecord = new TrainingRecord(trainingRecord);
 
            this.getTrainingTypesForCompany();
            this.operativesService.getOperativeById(this.trainingRecord.operativeId).subscribe(o => {
              this.operative = o;
              this.populateBreadcrumbs();
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
            this.observationsService.getTrainingRecordObservations(this.trainingRecordId, this.companyId).subscribe(observations => {
              observations?.forEach(ob => {
                ob.observationTypeString = ObservationTypeString[ob.observationType];
              });
              this.trainingRecordObservations = observations;
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
            this.getTrainingRecordDocuments();
            this.isTrainingRecordLoading = false;

          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        }
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });


  }

  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
  }

  private getTrainingTypesForCompany() {
    this.isTrainingRecordLoading = true;
    this.trainingRecordsService.getTrainingTypesForCompany(this.companyId).subscribe(results => {
      this.trainingRecordTypes = results;
      this.isTrainingRecordLoading = false;
      //results.forEach(t => {
      //  this.trainingRecordTypes.push(t);
      //});
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  editDetails() {
    if (this.trDetailsContainerComponent.isCollapsed) {
      //this.trDetailsContainerComponent.expandClicked();
      this.trDetailsContainerComponent.panelToggle();
    }
    this.editingDetails = true;
    // this.tempTrainingRecord = new TrainingRecord(this.trainingRecord);
  }

  saveDetails() {
    if (this.tempTrainingRecord.isValid) {
      this.isTrainingRecordLoading = true;
      this.trainingRecordsService.createOrUpdateTrainingRecord(new TrainingRecord(this.tempTrainingRecord)).subscribe(trainingRecord => {
        this.trainingRecord = new TrainingRecord(trainingRecord);
        this.tempTrainingRecord = new TrainingRecord(this.trainingRecord as ITrainingRecord);
        // this.tempTrainingRecord = new TrainingRecord({} as ITrainingRecord);
        this.editingDetails = false;
        this.isTrainingRecordLoading = false;
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
    }

  }

  cancelEdit() {
    this.tempTrainingRecord = new TrainingRecord(this.trainingRecord as ITrainingRecord);
    this.editingDetails = false;
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({ label: 'Operatives', iconName: 'users', routeLink: '/operatives' } as IBreadcrumb);
    operativeBreadCrumbs.push({
      label: `${this.operative.firstName} ${this.operative.middleInitials} ${this.operative.lastName}`,
      iconName: 'user',
      routeLink: `/operative/${this.operative.id}`
    } as IBreadcrumb);
    operativeBreadCrumbs.push({ label: this.trainingRecord?.trainingType?.name, iconName: 'book' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  addTrainingRecordDocument() {
    this.documentModalService.openDocumentUploaderModal(null, DocumentEntityType.trainingRecord, 'Add Document')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close();
          documentUploadRequest.append('TrainingRecordId', this.trainingRecord.id);
          documentUploadRequest.append('CompanyId', this.companyId);

          this.trainingRecordDocumentService
            .createOrUpdateTrainingRecordDocument(documentUploadRequest).subscribe(trainingRecordSummary => {
              this.trainingRecordDocuments.unshift(trainingRecordSummary);
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
        });
      });
  }

  viewTrainingRecordDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.router.navigate(['training-record-document', entityDocumentSummary.documentId]);
  }


  downloadTrainingRecordDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(entityDocumentSummary, true);
  }

  openTrainingRecordDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.documentService.downloadOrOpenDocument(entityDocumentSummary);
  }

  deleteTrainingRecordDocumentClick(entityDocumentSummary: IEntityDocumentSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to remove this document?',
      'Remove ' + entityDocumentSummary.originalFilename, new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.deleteOperativeDocument(entityDocumentSummary);
          }
        }
      });
  }

  deleteOperativeDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.trainingRecordDocumentService.deleteTrainingRecordDocument(entityDocumentSummary.documentId, this.companyId).subscribe(
      result => {
        if (result) {
          const documentIndex = this.trainingRecordDocuments.findIndex(c => c.documentId !== entityDocumentSummary.documentId);
          this.trainingRecordDocuments.splice(documentIndex, 1);
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

        }
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
  }

  editTrainingRecordDocument(entityDocumentSummary: IEntityDocumentSummary) {
    this.documentModalService.openDocumentUploaderModal(entityDocumentSummary, DocumentEntityType.trainingRecord, 'Edit Training Record Document')
      .subscribe(documentModalRef => {
        documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
          documentModalRef.dynamicDialogRef.close();
          documentUploadRequest.append('TrainingRecordId', this.trainingRecord.id);
          documentUploadRequest.append('CompanyId', this.companyId);
          this.trainingRecordDocumentService.createOrUpdateTrainingRecordDocument(documentUploadRequest)
            .subscribe(updatedTrainingRecordSummary => {
              this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
              const documentIndex = this.trainingRecordDocuments.findIndex(d => d.documentId === entityDocumentSummary.documentId);
              this.trainingRecordDocuments[documentIndex] = updatedTrainingRecordSummary;
            },
              uploadError => {

              });
        });
      });
  }

  createOrEditObservation(observation?: IObservation, isEditing?: boolean, heading?: string, observationType?: ObservationType, showSaveAndUploadButton?: boolean) {
    this.observationModalService.createOrEditObservation(observation, heading, isEditing, observationType, showSaveAndUploadButton).subscribe(observationModalRef => {
      observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
        if (observationResult !== null) {
          let entityObservationId = '00000000-0000-0000-0000-000000000000';
          this.trainingRecordObservations?.forEach(trObservationSummary => {
            if (trObservationSummary.observationId === observationResult.id) {
              entityObservationId = trObservationSummary.trainingRecordObservationId;
            }
          });
          this.observationsService.createOrUpdateTrainingRecordObservation(observationResult as IObservation, this.trainingRecordId, this.companyId, entityObservationId).subscribe(trainingRecordObservation => {
            this.trainingRecordObservations = this.observationsService.updateObservationSummaries(this.trainingRecordObservations, trainingRecordObservation);
            this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
            this.trainingRecordObservations?.forEach(ob => {
              ob.observationTypeString = ObservationTypeString[ob.observationType];
            });
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
          observationModalRef.dynamicDialogRef.close();

        }
      })
      observationModalRef.content.saveObservationDocumentRequested.subscribe(observationResult => {
        if (observationResult !== null) {
          const editedObservation = new Observation({
            id: observationResult.id,
            summaryInfo: observationResult.summaryInfo,
            notesAsHtml: observationResult.notesAsHtml,
            observedBy: observationResult.observedBy,
            observedOn: observationResult.observedOn,
            followUpOn: observationResult.followUpOn,
            observationType: observationResult.observationType
          } as IObservation);
          let entityObservationId = '00000000-0000-0000-0000-000000000000';
          this.trainingRecordObservations?.forEach(trObservationSummary => {
            if (trObservationSummary.observationId === observationResult.id) {
              entityObservationId = trObservationSummary.trainingRecordObservationId;
            }
          });
          this.observationsLoading = true;
          this.observationsService.createOrUpdateTrainingRecordObservation(editedObservation, this.trainingRecordId, this.companyId, entityObservationId).subscribe(trainingRecordObservation => {
            this.operativeObservationsSummary = this.observationsService.updateObservationSummaries(this.operativeObservationsSummary, trainingRecordObservation);
            this.operativeObservationsSummary?.forEach(ob => {
              ob.observationTypeString = ObservationTypeString[ob.observationType];
            });
            this.observationsLoading = false;
            //this.getTrainingRecordsForOperative(); Possibly to do with reloading changes after an observation has been edited/created
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
          observationModalRef.dynamicDialogRef.close();
          this.documentModalService.openDocumentUploaderModal({ documentCreationDate: observationResult.ObservedOn } as IEntityDocumentSummary
            , DocumentEntityType.employedPerson, 'Add new Document for Observation')
            .subscribe(documentModalRef => {
              documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
                documentModalRef.dynamicDialogRef.close();
                //this.addingOperativeDocuments = true;
                documentUploadRequest.append('OperativeId', this.operative.id);
                documentUploadRequest.append('CompanyId', this.companyId);
                this.operativeDocumentService.createOrUpdateOperativeDocument(documentUploadRequest).subscribe(operativeDocumentSummary => {
                  //this.getOperativeDocuments();
                  //this.addingOperativeDocuments = false;
                  this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();

                }, () => {
                  this.errorHandlingService.showErrorWarning().subscribe(() => {
                    // this.router.navigateByUrl('/dashboard');
                  });
                });
              });
            });
        }
      })









    });
  }

  getTrainingRecordDocuments(includeExpired: boolean = false) {
    this.trainingRecordDocumentService.getAllTrainingRecordDocumentSummaries(this.companyId, this.trainingRecord.id, includeExpired).subscribe(trainingRecordDocuments => {
      this.trainingRecordDocuments = [];
      trainingRecordDocuments.forEach(doc => this.trainingRecordDocuments.push(doc));
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  openTrainingRecordDetailsHelp() {
    this.helpService.openHelpModal(HelpConsts.TrainingRecordHelp);
  }

  saveNewCompanyTrainingType(trainingType: ITrainingType) {
    if (trainingType !== null) {

      trainingType.companyId = this.companyId;
      this.trainingRecordsService.createOrUpdateCompanyTrainingType(trainingType).subscribe(trainingType => {
        if (trainingType) {
          this.getTrainingTypesForCompany();
          this.tempTrainingRecord.trainingTypeId = trainingType.id;
          this.tempTrainingRecord.validTo = trainingType.validTo;
        }
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
    }
  }
}
